export class User {

    constructor (
        public name: string,
        public email: string,
        public password: string,
        public role ?: string,
        public _id ?: string,
        // Usuario Inscripto
        public apellido ?: string,
        public lang ?: string,
        public dni ?: string,
        public paisResidencia ?: string,
        public lugarTrabajo ?: string,
        public cargo ?: string,
        public direccionLaboral ?: string,
        public provincia ?: string,
        public ciudad ?: string,
        public codPostal ?: string,
        public paisTrabajo ?: string,
        public telefono ?: string,
        public pago ?: boolean,
        public aprobado ?: boolean,
        public invitado ?: boolean,
        public socio ?: boolean,
        public sociedad ?: string,
        public comunicacionesLibres ?: boolean,
        public estadoTrabajo ?: string,
        public estadoTrabajoInvitado ?: string,
        public total ?: number,
        public moneda ?: string,
        public congreso ?: string,
        public categoriaInscripcion ?: any,
        public actividades ?: any[],
        public comprobante ?: string,
        public conferencia ?: boolean,
        public trabajosInvitado ?: any[],
        public facturaRazonSocial ?: string,
        public facturaDireccion ?: string,
        public facturaCuit ?: string,
        public facturaCondicionIva ?: string,
        public facturaFechaEnvio ?: string,
        public paypalIdPago ?: string
    ) { }

}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts